import theme from '../../base';

const globals = {
  body: {
    bg: theme.colors.neutrals.gray900,
    foreground: theme.colors.neutrals.white,
  },
  anchor: {
    foreground: theme.colors.blues.blue300,
    foregroundHover: theme.colors.blues.blue200,
    foregroundActive: theme.colors.blues.blue300,
  },
};

export default globals;
